import { Directive, Input } from '@angular/core';
import { Stats } from '@zero/statistics/domain';

@Directive()
export class MyStatsBase {
  @Input() public stats: Stats;
  @Input() public accountTotal: number;
  @Input() public loading: boolean;
}
